import seedrandom from 'seedrandom';

// Generate a random seed string
export function generateSeed(length = 12) {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let seed = '';
  for (let i = 0; i < length; i++) {
    seed += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return seed;
}

// Validate and sanitize seed
export function validateSeed(seed) {
  if (!seed || typeof seed !== 'string') return null;
  
  // Remove invalid characters, keep only alphanumeric
  const sanitized = seed.toLowerCase().replace(/[^a-z0-9]/g, '');
  
  // Truncate if too long
  if (sanitized.length > 64) {
    return sanitized.substring(0, 64);
  }
  
  return sanitized.length > 0 ? sanitized : null;
}

// Get seed from URL or generate new one
export function getSeedFromURL() {
  const params = new URLSearchParams(window.location.search);
  const urlSeed = params.get('seed');
  const validated = validateSeed(urlSeed);
  return validated || generateSeed();
}

// Update URL with seed
export function updateSeedInURL(seed) {
  const url = new URL(window.location.href);
  url.searchParams.set('seed', seed);
  window.history.replaceState({}, '', url.toString());
}

// Create a seeded RNG
export function createSeededRNG(seed) {
  return seedrandom(seed);
}

// Shuffle array using seeded RNG
export function shuffle(array, rng) {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

// Random integer between min (inclusive) and max (exclusive) using seeded RNG
export function randomInt(min, max, rng) {
  return Math.floor(rng() * (max - min)) + min;
}

// Format time as M:SS
export function formatTime(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

// Check if two cells are adjacent (orthogonal only)
export function areAdjacent(cell1, cell2) {
  const rowDiff = Math.abs(cell1.row - cell2.row);
  const colDiff = Math.abs(cell1.col - cell2.col);
  return (rowDiff === 1 && colDiff === 0) || (rowDiff === 0 && colDiff === 1);
}

// Check if gems can be merged (same type, same tier, adjacent)
export function canMerge(gem1, gem2) {
  return gem1 && gem2 &&
         gem1.type === gem2.type &&
         gem1.tier === gem2.tier &&
         gem1.tier < 3; // Max tier is 3
}
